import i18n from '@/i18n'
export default [
    {
        value: true,
        text: i18n.t('form.switch.yes'),
    },
    {
        value: false,
        text: i18n.t('form.switch.no'),
    },
]
